/**
 * Banner shown when the floor balances tables and the player's seat
 * changes. Renders above the clock with a warn-toned background so it
 * pulls the eye without taking over the screen (the clock must remain
 * visible — players might be mid-hand at the old table).
 *
 * Visibility is owned by the parent (ActiveView), which detects the
 * tableNumber/seatNumber change via a ref-tracked baseline and decides
 * when to mount this. The dismiss action is also parent-owned so the
 * notice can be re-triggered if the player gets moved again.
 *
 * Copy ends with "Ta med chipsene." — the friction-reducer for a player
 * who's never been moved mid-tournament before and doesn't know the
 * convention.
 */
const TableMoveBanner = ({
  fromTable,
  fromSeat,
  toTable,
  toSeat,
  onDismiss,
}: {
  fromTable: number
  fromSeat: number
  toTable: number
  toSeat: number
  onDismiss: () => void
}) => (
  <div
    role="alert"
    aria-live="polite"
    className="relative mx-2 my-3 rounded-lg shadow bg-gold text-ink-900 px-4 py-3"
  >
    <div className="flex items-start gap-3">
      <span aria-hidden className="text-2xl shrink-0">
        🪑
      </span>
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold text-sm uppercase tracking-wider">
          Du flyttes
        </div>
        <div className="text-sm mt-0.5 num">
          <span className="text-ink-700">
            Bord <span className="font-mono num font-bold">{fromTable}</span> ·
            Sete <span className="font-mono num font-bold">{fromSeat}</span>
          </span>
          <span aria-hidden className="mx-2 text-ink-500">
            →
          </span>
          <span>
            Bord <span className="font-mono num font-bold">{toTable}</span> ·
            Sete <span className="font-mono num font-bold">{toSeat}</span>
          </span>
        </div>
        <div className="text-[11px] text-ink-700 mt-1">Ta med chipsene.</div>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Lukk varsel"
        className="text-ink-700 active:opacity-70 shrink-0 -mr-1 -mt-1 p-1"
      >
        <span aria-hidden className="text-lg leading-none">
          ×
        </span>
      </button>
    </div>
  </div>
)

export default TableMoveBanner
